import React from 'react';
import hero from 'public/landing/hero-mecca.png';

const Hero = () => (
  <section
    className="relative flex min-h-[480px] items-center justify-center px-6 py-[58px] text-center text-white min-[681px]:min-h-[500px] min-[681px]:px-7 min-[681px]:py-16"
    aria-labelledby="landing-title"
  >
    <img className="absolute inset-0 h-full w-full object-cover object-[50%_54%]" src={hero} alt="" />
    <div
      className="absolute inset-0 bg-[linear-gradient(#10181147,#1018117d_43%,#1018115e_65%,#1018111f)]"
      aria-hidden="true"
    />
    <div className="relative w-full max-w-[940px]">
      <h1
        id="landing-title"
        className="text-[33px] font-bold leading-[1.18] text-inherit min-[681px]:text-5xl min-[681px]:leading-[1.18]"
      >
        Plateforme officielle pour le Hadj
      </h1>
      <p className="mx-auto mt-7 max-w-[750px] text-base leading-[1.75] text-inherit min-[681px]:text-lg min-[681px]:leading-[1.75]">
        Centralisez, simplifiez et sécurisez chaque étape de votre pèlerinage à La Mecque grâce à une plateforme
        officielle, fiable et transparente.
      </p>
    </div>
  </section>
);
export default Hero;
